// dateUtils.js
export function formatDate(dateString) {
    // Parse the date string (stored in Hygraph as UTC)
    const date = new Date(dateString);
    // Create arrays for days and months in Dutch
    const days = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
    const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    // Convert UTC -> Europe/Brussels. This handles winter/summer time (CET/CEST)
    // automatically, instead of hardcoding a +2 offset all year round.
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Brussels',
        weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(date).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
    }, {});
    // Get the components (already in Belgian local time)
    const dayOfWeek = days[['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday)];
    const day = Number(parts.day);
    const month = months[Number(parts.month) - 1];
    const hours = Number(parts.hour) % 24; // Intl can return "24" at midnight
    const minutes = parts.minute;
    // Format the date string
    return `${dayOfWeek}, ${day} ${month} - ${hours}:${minutes}`;
}
